export default __webpack_public_path__ + "static/stakeholder-332f2303f01e05accf0ce247321535c1.png";